// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"bE3yo":[function(require,module,exports) {
class InstitutionSingle {
    constructor(){
        this.handleModalVisibility();
        this.handleOpeningHours();
        this.handleViewBannerImage();
        this.handleScrollCarousel("institution-communities", "institution-communities-left", "institution-communities-right");
        this.handleScrollCarousel("institution-chapels", "institution-chapels-left", "institution-chapels-right");
    }
    handleScrollCarousel(listId, prevId, nextId) {
        const list = document.getElementById(listId);
        const prevButton = document.getElementById(prevId);
        const nextButton = document.getElementById(nextId);
        if (!list || !prevButton || !nextButton) return;
        const scrollAmount = 240;
        prevButton.addEventListener("click", ()=>{
            list.scrollBy({
                left: -scrollAmount,
                behavior: "smooth"
            });
        });
        nextButton.addEventListener("click", ()=>{
            list.scrollBy({
                left: scrollAmount,
                behavior: "smooth"
            });
        });
    }
    handleViewBannerImage() {
        const button = document.querySelector("#view-institution-banner-image");
        if (button) button.addEventListener("click", ()=>{
            const imageSrc = document.querySelector("#institution-photo-field img").src;
            const imageAlt = document.querySelector("#institution-photo-field img").alt;
            const modalHtml = `
					<div id="wp-parresia-register-single-banner-popup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
						<div class="relative bg-white overflow-hidden max-w-4xl mx-4">
							<span id="wp-parresia-register-single-banner-popup-close" class="absolute z-10 top-5 right-5 !text-white cursor-pointer bg-black bg-opacity-30 rounded-md p-1 hover:bg-opacity-50 focus:outline-none">
								<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
								</svg>
							</span>
							<div class="overflow-hidden relative bg-white p-4">
								<img src="${imageSrc}" alt="${imageAlt}" class="h-auto object-fill !rounded-none">
							</div>
						</div>
					</div>
				`;
            document.body.insertAdjacentHTML("beforeend", modalHtml);
            const modal = document.querySelector("#wp-parresia-register-single-banner-popup");
            const closeBtn = document.querySelector("#wp-parresia-register-single-banner-popup-close");
            closeBtn.addEventListener("click", ()=>{
                modal.remove();
            });
            modal.addEventListener("click", (e)=>{
                if (e.target === modal) modal.remove();
            });
        });
    }
    handleOpeningHours() {
        const horary = document.querySelector("#institution-organisms-section-opening-hours");
        const horaryList = document.querySelector("#institution-organisms-section-opening-hours-list");
        if (horary) horary.addEventListener("click", ()=>{
            horaryList.classList.toggle("hidden");
        });
    }
    handleModalVisibility() {
        const modal = document.querySelector("#wp-parresia-register-single-horary-popup");
        const triggers = document.querySelectorAll("#wp-parresia-register-single-horarys .wp-parresia-register-single-horary");
        const close = document.querySelector("#wp-parresia-register-single-horary-popup-close");
        triggers.forEach((trigger)=>{
            trigger.addEventListener("click", ()=>this.openModal(modal, trigger));
        });
        if (close) close.addEventListener("click", ()=>this.closeModal(modal));
        document.addEventListener("click", (e)=>{
            if (e.target === modal) this.closeModal(modal);
        });
    }
    openModal(modal, trigger) {
        modal.classList.remove("hidden");
        const data = JSON.parse(trigger.getAttribute("data-item"));
        if (data) this.fillModal(data);
    }
    closeModal(modal) {
        modal.classList.add("hidden");
    }
    fillModal(data) {
        const name = document.querySelector("#wp-parresia-register-single-horary-popup-name");
        const recurrence = document.querySelector("#wp-parresia-register-single-horary-popup-recurrence");
        const weekdays = document.querySelector("#wp-parresia-register-single-horary-popup-weekdays");
        const schedules = document.querySelector("#wp-parresia-register-single-horary-popup-schedules");
        name.innerHTML = data.name;
        recurrence.innerHTML = data.line_recurrence;
        weekdays.innerHTML = data.line_weekdays;
        schedules.innerHTML = this.buildScheduleList(data.schedules) + ` - ${data.description}`;
    }
    buildScheduleList(schedules) {
        const formattedSchedules = [];
        schedules.forEach((schedule)=>{
            let scheduleString = "";
            if (schedule.hour) scheduleString += schedule.hour;
            if (schedule.celebrant_name && schedule.celebrant_name !== undefined) {
                if (scheduleString) scheduleString += ` - ${schedule.celebrant_name}`;
                else scheduleString += schedule.celebrant_name;
            }
            if (scheduleString) formattedSchedules.push(scheduleString);
        });
        return formattedSchedules.join(" / ");
    }
}
document.addEventListener("DOMContentLoaded", ()=>{
    new InstitutionSingle();
});

},{}]},["bE3yo"], "bE3yo", "parcelRequire734e")

//# sourceMappingURL=institution-single.js.map
